import React from "react";
import { Route, Redirect } from "react-router-dom";
import store from "../redux/store";

// SAM-007: `allowTo` is a client-side gate so that typing a privileged URL
// directly (e.g. `/users`) can't reach the screen. The nav already hides these
// links via its own `allowTo`, but the route itself had no check, so an
// inspector could still spoof the path. The server is the real authorization
// boundary for the data; this just stops the inspector landing on a screen
// they were never meant to open.
export const RouteWithLayout = ({
  component: Component,
  layout: Layout,
  allowTo,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      if (allowTo) {
        const state = store.getState();
        const role =
          state.user && state.user.profile && state.user.profile.role;
        if (allowTo.indexOf(role) === -1) {
          return <Redirect to="/" />;
        }
      }
      return (
        <Layout>
          <Component {...props} {...rest} />
        </Layout>
      );
    }}
  />
);
